/*
 * @Author: tkp
 * @Date: 2025-07-18 15:25:13
 */
import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/index',
    component: resolve => require(['@/layout/home'], resolve),
    children: [
      {
        path: '/index',
        name: 'index',
        component: resolve => require(['@/view/index/index'], resolve),
      },
      {
        path: '/about',
        name: 'about',
        component: resolve => require(['@/view/about/index'], resolve),
      },
      {
        path: '/contact',
        name: 'contact',
        component: resolve => require(['@/view/contact/index'], resolve),
      },
      {
        path: '/workflow',
        name: 'workflow',
        component: resolve => require(['@/view/workflow/index'], resolve),
      },
      {
        path: '/matrix',
        name: 'matrix',
        component: resolve => require(['@/view/matrix/index'], resolve),
      },
      {
        path: '/default',
        name: 'default',
        component: resolve => require(['@/view/default/index'], resolve),
      }
    ]
  }
  ]
})
//挂载路由导航守卫
router.beforeEach(function (to, from, next) {
  next();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js